/* eslint-disable radix */
export const isProductInCart = (id, list) => {
  if (list.length === 0) return false
  return !!list.find(el => parseInt(el) === id)
}
